import { TOAST_TIMEOUT } from 'src/config/Toast';
import store from 'src/store';
import { type Site } from 'src/store/siteSlice';
import { createToast } from 'src/store/toastsSlice';
import apiClient from 'src/utils/apiClient';

class UserSiteConfigService {
  /**
   * get all sites
   * @returns {Object}
   */
  public getAllowedSites() {
    return apiClient.get('/sites/allowed');
  }

  /**
   * get users site configs
   * @returns {Object}
   */
  public getUserSiteConfig(alias: string) {
    return apiClient.get(`/userSiteConfig/login/${alias}`);
  }

  /**
   * update user sites config
   * @returns {Object}
   */
  public updateUserSites(alias: string, sites: Site[]) {
    const response = apiClient.post('/userSiteConfig', {
      login: alias,
      defaultSites: sites,
    });
    store.dispatch(
      createToast({
        type: 'success',
        message: 'Updated settings successfully',
        timeout: TOAST_TIMEOUT,
      }),
    );
    return response;
  }
}
export default new UserSiteConfigService();
